@if(control()) {
    <div class="boolean-selector">
        <mat-slide-toggle
            class="toggle"
            [formControl]="control()"
        />
        <label>
            <span [innerHTML]="question | translate"></span>      
            @if(tooltipText) {
                <button type="button" mat-icon-button color="primary"
                    [matTooltip]="tooltipText | translate" 
                    matTooltipClass="custom-tooltip"
                    matTooltipPosition="above"
                >
                    <mat-icon>info_outline</mat-icon>
                </button>
            }                      
        </label>
    </div>
}
